import { render } from "./WhiteBoxMain.vue?vue&type=template&id=9e6bcbf0&scoped=true"
import script from "./WhiteBoxMain.vue?vue&type=script&lang=js"
export * from "./WhiteBoxMain.vue?vue&type=script&lang=js"

import "./WhiteBoxMain.vue?vue&type=style&index=0&id=9e6bcbf0&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6bcbf0"]])

export default __exports__